const t=t=>!/^[A-Za-z][\d+.A-Za-z-]*:/.test(t);export{t as isHrefRelative};
